import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TenantFeatures, DEFAULT_TENANT_FEATURES } from './tenant-theme.interface';

@Injectable({ providedIn: 'root' })
export class TenantFeatureService {
  private featuresSubject = new BehaviorSubject<TenantFeatures>(DEFAULT_TENANT_FEATURES);
  features$: Observable<TenantFeatures> = this.featuresSubject.asObservable();

  apply(features: Partial<TenantFeatures>): void {
    // Build an all-false base from the known keys so that any flag
    // NOT provided by the backend is treated as disabled.
    const allFalse = Object.keys(DEFAULT_TENANT_FEATURES).reduce(
      (acc, key) => ({ ...acc, [key]: false }),
      {} as Record<string, boolean>
    );
    this.featuresSubject.next({ ...allFalse, ...features } as TenantFeatures);
  }

  isEnabled(flag: string): boolean {
    return this.featuresSubject.value[flag] ?? false;
  }

  getSnapshot(): Readonly<TenantFeatures> {
    return this.featuresSubject.value;
  }

  reset(): void {
    this.featuresSubject.next(DEFAULT_TENANT_FEATURES);
  }
}
